
export const KartenStyle = {
    root: {
        width: 300,
        background: 'lightgrey',
        color: 'black',
        borderRadius: 20,
        margin: 10,
        position: 'relative',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
};
